// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_bee5595"};